import React, { useState } from 'react'
import {
  Box,
  Button,
  FormControl,
  Grid,
  MenuItem,
  Modal,
  Select,
} from '@material-ui/core'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Typography from '@mui/material/Typography'
import { Autocomplete, TextField } from '@mui/material'
import ReactTooltip from 'react-tooltip'
import ExitIcon from '@material-ui/icons/ExitToApp'
import SaveIcon from '@material-ui/icons/Save'
import CancelIcon from '@mui/icons-material/Cancel'
import { Popup } from 'devextreme-react'
// import * as Yup from 'yup'
// import { useFormik } from 'formik'
// import { useAuthentication } from '../../../context/authenticationContext'

export const ModalQuestionary = ({ open, setOpen }) => {
  const [popupVisible, setPopupVisible] = useState(false)
  // const { userIDB2C } = useAuthentication()

  // const GeneralDataSchema = Yup.object().shape({})

  // const formik = useFormik({
  //   enableReinitialize: true,
  //   validateOnChange: false,
  //   initialValues: {
  //     IdQuestionnaireAnswer: 0,
  //     Disbursements: '',
  //     IdAdaptationAction: '',
  //     ComplianceDate: '',
  //     IdFormAction: 57,
  //     IdUserAzureB2C: userIDB2C,
  //     Draft: false,
  //   },
  //   validationSchema: GeneralDataSchema,
  //   onSubmit: (values) => {
  //     handleGuardar(values)
  //   },
  // })

  const onHiding = async () => {
    setPopupVisible(false)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const options = [
    {
      label:
        '1. ¿Pretende usted con el proyecto, instalar sistema de cosecha (captación) de aguas lluvias? ',
      year: 1994,
    },
    { label: '2. ¿Pretende instalar sistemas de riego?', year: 1994 },
  ]

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modalPYME">
          <Grid
            container
            md={12}
            sm={12}
            spacing={1}
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            <Grid item>
              <div
                data-tip
                onClick={handleClose}
                data-for="exitPop"
                style={{
                  backgroundColor: '#014b96',
                  color: '#fff',
                  width: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '4px',
                  padding: '5px',
                  cursor: 'pointer',
                }}
              >
                <ExitIcon style={{ transform: 'scaleX(-1)' }} />
                <ReactTooltip
                  id="exitPop"
                  effect="solid"
                  backgroundColor="#014b96"
                >
                  <span>Regresar</span>
                </ReactTooltip>
              </div>
            </Grid>

            <Grid item>
              <div
                data-tip
                onClick={() => {
                  setPopupVisible(true)
                }}
                data-for="cancelPop"
                style={{
                  backgroundColor: 'red',
                  color: '#fff',
                  width: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '4px',
                  padding: '5px',
                  cursor: 'pointer',
                }}
              >
                <CancelIcon style={{ transform: 'scaleX(-1)' }} />
                <ReactTooltip
                  id="cancelPop"
                  effect="solid"
                  backgroundColor="red"
                >
                  <span>Cancelar</span>
                </ReactTooltip>
              </div>
            </Grid>

            <Grid item>
              <div
                data-tip
                data-for="savePop"
                style={{
                  backgroundColor: '#5cb85c',
                  color: '#fff',
                  width: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '4px',
                  padding: '5px',
                  cursor: 'pointer',
                }}
              >
                <SaveIcon />
              </div>
              <ReactTooltip
                id="savePop"
                effect="solid"
                backgroundColor="#5cb85c"
              >
                <span>Guardar </span>
              </ReactTooltip>
            </Grid>
          </Grid>

          {/* Popup Cancel */}
          <Popup
            title="Acciones disponible IFI"
            showTitle={true}
            width={600}
            height={350}
            visible={popupVisible}
            hideOnOutsideClick
            onHiding={onHiding}
          >
            <Grid container spacing={1}>
              <Grid container spacing={1} className="input__container">
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">Acción</label>
                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                  <FormControl fullWidth>
                    <Select
                      id="IdProject"
                      name="IdProject"
                      variant="outlined"
                      displayEmpty={true}
                      onChange={(e) => {}}
                      disabled
                    >
                      <MenuItem disabled value="">
                        Seleccione una opción
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">Observaciones</label>
                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                  <FormControl fullWidth>
                    <textarea
                      id="ClimateThreat"
                      placeholder="Observaciones"
                      customInput={TextField}
                    ></textarea>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid className="buttonsPYME">
                <Button className="cancelButton" onClick={onHiding}>
                  Cancelar
                </Button>

                <Button className="confirmButton">Guardar</Button>
              </Grid>
            </Grid>
          </Popup>
          {/* Fin popup Cancel */}

          <div className="pymeDiv">
            <h1 className="pymeTitle">
              Cuestionario de Monitoreo y Evaluación
            </h1>
            <p className="pymeDescription">
              Proporcione la información solicitada para iniciar Monitoreo y
              Evaluación
            </p>
          </div>
          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={6} md={6}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  1.1. Nombre de la MIPYME
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl fullWidth>
                  <Select
                    id="IdProject"
                    name="IdProject"
                    variant="outlined"
                    displayEmpty={true}
                    onChange={(e) => {}}
                  >
                    <MenuItem disabled value="">
                      Seleccione una opción
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  1.2. Título del Subproyecto financiado
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl fullWidth>
                  <Select
                    id="IdProject"
                    name="IdProject"
                    variant="outlined"
                    displayEmpty={true}
                    onChange={(e) => {}}
                  >
                    <MenuItem disabled value="">
                      Seleccione una opción
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  1.2. Indicador de adaptación
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl fullWidth>
                  <Select
                    id="IdProject"
                    name="IdProject"
                    variant="outlined"
                    displayEmpty={true}
                    onChange={(e) => {}}
                  >
                    <MenuItem disabled value="">
                      Seleccione una opción
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
          <Grid container spacing={1} className="input__container">
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography sx={{ fontWeight: 'bold' }}>
                  1.4 Partiendo de la medida de adaptación., la MIPYME se
                  compromete a: <br /> El cumplimiento del ítem que la mipyme
                  seleccione será verificado por la IFI, para asegurar el
                  otorgamiento del premio, el cual está sujeto a disponibilidad
                  de fondos.
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={1} clasName="input__container">
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">1. Pregunta Clave</label>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl style={{ width: '100%' }}>
                      <Autocomplete
                        // getOptionLabel={(options) => {
                        //   options.label
                        // }}
                        disablePortal
                        id="combo-box-demo"
                        options={options}
                        sx={{ width: '100%' }}
                        renderInput={(params) => <TextField {...params} />}
                        onChange={(e, value) => {}}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      2. Pregunta Secundaria
                    </label>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl style={{ width: '100%' }}>
                      <Autocomplete
                        // getOptionLabel={(options) => {
                        //   options.label
                        // }}
                        disablePortal
                        id="combo-box-demo"
                        options={options}
                        sx={{ width: '100%' }}
                        renderInput={(params) => <TextField {...params} />}
                        onChange={(e, value) => {}}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">3. Respuesta</label>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl style={{ width: '100%' }}>
                      <TextField
                        id="MiPymeCountry"
                        name="MiPymeCountry"
                        type="text"
                        variant="outlined"
                        sx={{ width: '100%' }}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={6} md={6}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  1.5. Fecha de cumplimiento de la medida de adaptación
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl fullWidth>
                  <TextField
                    id="ImplementationDateStart"
                    type="date"
                    name="ImplementationDateStart"
                    variant="outlined"
                    sx={{ width: '100%' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </FormControl>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">1.6. Estado</label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl fullWidth>
                  <Select
                    id="IdProject"
                    name="IdProject"
                    variant="outlined"
                    displayEmpty={true}
                    onChange={(e) => {}}
                    style={{ height: 40 }}
                  >
                    <MenuItem disabled value="">
                      Seleccione una opción
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <Grid className="buttonsPYME">
              <Button className="confirmButton" type="button">
                Registrar
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  )
}
